// Activity events AppLogout listens for to reset its idle-logout safety-net timer — matches AppBar.js's own list.
export const IDLE_ACTIVITY_EVENTS = ["load", "mousemove", "mousedown", "click", "scroll", "keypress", "touchstart", "touchmove"];

// Idle time after which the session ends — AppBar's warning/logout timer and the startup stale-session check in index.js both use it.
export const IDLE_LOGOUT_SECONDS = 1800; // 30 min

// localStorage key AppBar writes to on every local activity event — writing it fires the "storage" event in every *other* same-origin tab.
export const LAST_ACTIVITY_KEY = "lastActivity";

// Minimum gap between two activity resets — mousemove/keydown/etc. fire far more often than this, so extra events in between are ignored.
export const ACTIVITY_THROTTLE_MS = 10000;

// localStorage key holding the absolute ms timestamp the next token refresh is due — shared across tabs so only one of them actually calls /refresh per cycle.
export const TOKEN_REFRESH_DUE_AT_KEY = "tokenRefreshDueAt";

// Password age (in days) after which AppLogout prompts the user to change it.
export const PASSWORD_EXPIRY_DAYS = 180;

// Why the most recent logout happened ('auto' | 'manual') — other tabs read this to decide whether to show the inactivity message.
export const LOGOUT_REASON_KEY = "logoutReason";

// sessionStorage flag set when a 401 ends the session — Login.tsx reads it to show the "session expired" message.
export const SESSION_EXPIRED_MESSAGE_KEY = "sessionExpiredMessage";

// Fraction of the token's real lifetime AppBar waits before refreshing — 25/30 fires at the 25-minute mark of a 30-minute token.
export const REFRESH_BUFFER_RATIO = 25 / 30;

// Fallback for the first refresh cycle after mount, before any server response — matches Cognito's access-token TTL.
export const DEFAULT_TOKEN_EXPIRES_IN_SECONDS = 1800;

// How soon AppBar retries after a transient (non-session-ending) refresh failure.
export const REFRESH_RETRY_DELAY_MS = 30 * 1000;

// Backend codes from /api/auth/refresh: TOKEN_EXPIRED is recoverable via refresh, REFRESH_TOKEN_EXPIRED means the session is truly over.
export const TOKEN_EXPIRED_CODE = "TOKEN_EXPIRED";
export const REFRESH_TOKEN_EXPIRED_CODE = "REFRESH_TOKEN_EXPIRED";

// Backend code when the access_token cookie is missing — usually the browser dropped it at expiry, so it's worth one refresh attempt.
export const UNAUTHORIZED_CODE = "UNAUTHORIZED";
